import { useEffect, useState } from "react";
import "./style.css";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import {
  apiCreateItem,
  apiListBranch,
  apiListGodown,
  apiListItemCat,
} from "../../../api/master";
import itemSchema from "../../../validations/itemSchema";
import {
  inputAlphanum,
  inputAlphanumSpe,
  inputfourDigitDeciaml,
  inputNumber,
  inputOnlyNumber,
} from "../../../utils";
import addIcon from "../../../images/icons/add.png";
import deleteIcon from "../../../images/icons/delete.png";
import Swal from "sweetalert2";
import config from "../../../config";
import axios from "axios";
import { FaExchangeAlt } from "react-icons/fa";
import SimpleS3Upload from "../../../components/SimpleS3Upload";
import ImageUploader from "./ImageUploader";

function ItemCatAdd(props) {
  const [gGodown, setGodown] = useState([]);
  const [defaultGodown, setDefaultGodown] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [stock, setStock] = useState([
    { branch_id: "", godown_id: "", op_stock: "" },
  ]);
  const [item_godown_data, setItem_godown_data] = useState([
    { branch_id: "", godown_id: "" },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [selectedcode, setSelectedCode] = useState("");
  const [shownew, setShownew] = useState(false);
  const [displayError, setDisplayError] = useState("");
  const [godownError, setGodownError] = useState();
  const [brError, setBrError] = useState();
  const [branchError, setBranchError] = useState();
  const [defaultgodownError, setDefaultgodownError] = useState();
  const [godownQtyError, setGodownQtyError] = useState();
  const ItemUnitList = props.itemUnitList;

  const [allBranch, setAllBranch] = useState([]);
  const [allGodown, setAllGodown] = useState([]);
  const [allItemCat, setAllItemCat] = useState([]);
  const [unselectbranch, setUnselectbranch] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const token = JSON.parse(localStorage.getItem("inventory")).token;
  console.log("ItemUnitList", ItemUnitList);

  async function ItemGodowList() {
    const payload = { paginate: 0, is_active: 1 };
    await apiListGodown(payload).then((result) => {
      setAllGodown(result.data.data.list);
      setGodown(result.data.data.list);
    });
  }

  // useEffect(() => {
  //   setAllBranch(props?.allBranch);
  //   setAllGodown(props?.allGodown);
  // },[]);
  // console.log("props?.allBranch",props?.allBranch)
  // console.log("allBranch",allBranch)

  async function ItemBranchList() {
    const payload = { paginate: 0, is_active: 1 };
    await apiListBranch(payload).then((result) =>
      setAllBranch(result.data.data.list),
    );
  }

  async function ItemCatList() {
    const payload = { paginate: 0, is_active: 1 };
    await apiListItemCat(payload).then((result) =>
      setAllItemCat(result.data.data.list),
    );
  }

  useEffect(function () {
    ItemGodowList();
    ItemBranchList();
    ItemCatList();
  }, []);

  const godownListMap = gGodown?.flatMap((el) => {
    return {
      value: el?.godown_id,
      label: el?.godown_name,
    };
  });
  const branchListMap = allBranch?.flatMap((el) => {
    return {
      value: el?.branch_id,
      label: el?.branch_name,
    };
  });
  const itemCatListMap = allItemCat?.flatMap((el) => {
    return {
      value: el?.item_cat_id,
      label: el?.item_cat_name,
    };
  });

  const itemFormik = useFormik({
    initialValues: {
      item_name: "",
      video_url: "",
      item_cat_id: "",
      item_desc: "",
      item_price: "",
      alt_price: "",
      item_unit: "",
      alt_unit: "",
      alt_conv: "",
      item_min_price: "",
      alt_min_price: "",
      img_url: "",
      barcode: "",
      SKU: "",
      category_code: "",
      field_1: "",
      field_2: "",
      field_3: "",
    },
    validationSchema: itemSchema.validateItemAdd(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      setIsSubmit(true);
      if (
        values.alt_unit &&
        values.item_unit &&
        values.alt_unit !== values.item_unit &&
        Number(values.alt_conv) === 1
      ) {
        const alertResult = await Swal.fire({
          title: "Are you sure?",
          html:
            "1 of <b>" +
            values.item_unit +
            "</b> is equal to 1 of <b>" +
            values.alt_unit +
            "</b>. Please confirm.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, save",
          cancelButtonText: "No, cancel",
          reverseButtons: true,
        });

        if (!alertResult.isConfirmed) {
          setIsSubmit(false);
          return; // block submission
        }
      }

      // let input = {
      //   item_name: values.item_name,
      //   video_url: values.video_url,
      //   item_cat_id: values.item_cat_id,
      //   item_desc: values.item_desc,
      //   item_price: Number(values.item_price),
      //   alt_price: Number(values.alt_price),
      //   item_unit: values.item_unit,
      //   alt_unit: values.alt_unit,
      //   alt_conv: Number(values.alt_conv),
      //   item_min_price: Number(values.item_min_price),
      //   alt_min_price: Number(values.alt_min_price),
      //   img_url: values.img_url,
      // };
      const formData = new FormData();

      // Append all form fields
      formData.append("item_name", values.item_name);
      formData.append("video_url", values.video_url);
      formData.append("item_cat_id", values.item_cat_id);
      formData.append("item_desc", values.item_desc);
      formData.append("item_price", Number(values.item_price));
      formData.append("alt_price", Number(values.alt_price));
      formData.append("item_unit", values.item_unit);
      formData.append("alt_unit", values.alt_unit);
      formData.append("alt_conv", Number(values.alt_conv));
      formData.append("item_min_price", Number(values.item_min_price));
      formData.append("alt_min_price", Number(values.alt_min_price));
      formData.append("barcode", values.barcode);
      formData.append("SKU", values.SKU);
      formData.append("category_code", values.category_code || "");
      formData.append("field_1", values.field_1);
      formData.append("field_2", values.field_2);
      formData.append("field_3", values.field_3);

      if (imageFile) {
        formData.append("img_url", imageFile); // FormData के लिए 'image' field
      }

      // Stock data as JSON string
      // STOCK ARRAY
      let item_stock = stock.filter((s) => s.godown_id != "");

      item_stock.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          formData.append(`stock[${index}][${key}]`, item[key]);
        });
      });

      // GODOWN ARRAY
      let godown_data = item_godown_data.filter((s) => s.godown_id != "");

      godown_data.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          formData.append(`item_godown_data[${index}][${key}]`, item[key]);
        });
      });
      // let item_stock = stock.filter((s) => s.godown_id != "");
      // let godown_data = item_godown_data.filter((s) => s.godown_id != "");

      setGodownError("");
      setBrError("");
      setGodownQtyError("");
      setBranchError("");
      setDefaultgodownError("");

      if (stock.length === 1) {
        if (stock[stock.length - 1].branch_id == "") {
          setBrError("Branch Name is required");
          setIsSubmit(false);

          return;
        }
        if (stock[stock.length - 1].godown_id == "") {
          setGodownError("Gowdown Name is required");
          setIsSubmit(false);

          return;
        }

        if (stock[stock.length - 1].op_stock == "") {
          setGodownQtyError("Godown Opening Stock is required");
          setIsSubmit(false);

          return;
        }
      }

      // if (item_stock.length > 0) {
      //   input = { ...input, stock: item_stock };
      // }
      // if (godown_data.length > 0) {
      //   input = { ...input, item_godown_data: godown_data };
      // }
      // return;
      await apiCreateItem(formData)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          setShownew(true);
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
        });
    },
    onReset: async (values) => {
      setSelectedCode(null);
      itemFormik.resetForm();
      setShownew(false);
      setSuccess("");
      setDefaultGodown("");
      setStock(() => [{ branch_id: "", godown_id: "", op_stock: "" }]);
      setItem_godown_data(() => [{ branch_id: "", godown_id: "" }]);
      setImageFile(null);
      setImagePreview("");
    },
  });
  console.log(
    "itemFormikitemFormik",
    itemFormik?.values?.SKU,
    itemFormik?.values?.field_1,
    itemFormik?.values?.field_2,
    itemFormik?.values?.field_3,
  );

  useEffect(
    function () {
      const timer = setTimeout(() => {
        setSuccess("");
        setError("");
      }, 5000);
      return () => clearTimeout(timer);
    },
    [success, error],
  );

  const [unit, setUnit] = useState(false);

  useEffect(() => {
    if (itemFormik.values.item_unit == itemFormik.values.alt_unit) {
      setUnit(true);
      itemFormik.setFieldValue("alt_conv", 1);
      itemFormik.setFieldValue("alt_price", itemFormik.values.item_price);
      itemFormik.setFieldValue(
        "alt_min_price",
        itemFormik.values.item_min_price,
      );
    } else {
      setUnit(false);
    }
  }, [itemFormik.values]);

  console.log("itemFormik", itemFormik.values);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "20rem", height: "4px" }} id="modalhead">
          Add Item
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          onSubmit={itemFormik.handleSubmit}
          onReset={itemFormik.handleReset}
          autoComplete="off"
        >
          <div className="row gx-3 gy-2">
            <div className="col-md-6">
              <label htmlFor="item_name">
                Name <span className="text-danger">*</span>
              </label>
              <input
                maxLength={100}
                type="text"
                className="form-control"
                id="item_name"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("item_name")}
              />
              {itemFormik.errors.item_name && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.item_name}
                </div>
              ) : null}
            </div>

            <div className="col-md-6">
              <label htmlFor="item_cat_id">Category</label>
              <select
                className="form-select"
                name="item_cat_id"
                value={itemFormik.values.item_cat_id}
                onChange={(e) => {
                  itemFormik.setFieldValue("item_cat_id", e.target.value);
                }}
              >
                <option value="">Select</option>
                {itemCatListMap?.map((list) => {
                  return <option value={list?.value}>{list?.label}</option>;
                })}
              </select>
              {itemFormik.errors.item_cat_id && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.item_cat_id}
                </div>
              ) : null}
            </div>

            <div className="col-md-12">
              <label htmlFor="item_desc">Description</label>
              <textarea
                type="text"
                maxLength={2000}
                className="form-control"
                id="item_desc"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("item_desc")}
              />
              {itemFormik.errors.item_desc && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.item_desc}
                </div>
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <label htmlFor="item_unit">
                Base Unit <span className="text-danger">*</span>
              </label>
              <select
                type="text"
                className="form-select"
                id="item_unit"
                {...itemFormik.getFieldProps("item_unit")}
              >
                <option value="" hidden>
                  Select...
                </option>
                {ItemUnitList?.map((list) => {
                  return <option value={list?.value}>{list?.label}</option>;
                })}
              </select>
              {itemFormik.errors.item_unit ? (
                <div className="text-danger small">
                  {itemFormik.errors.item_unit}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="alt_unit">
                Alternate Unit <span className="text-danger">*</span>
              </label>
              <select
                type="text"
                className="form-select"
                id="alt_unit"
                {...itemFormik.getFieldProps("alt_unit")}
              >
                <option value="" hidden>
                  Select...
                </option>
                {ItemUnitList?.map((list) => {
                  return <option value={list?.value}>{list?.label}</option>;
                })}
              </select>
              {itemFormik.errors.alt_unit ? (
                <div className="text-danger small">
                  {itemFormik.errors.alt_unit}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="item_price">Base Conversion</label>
              <input
                autoComplete="off"
                type="text"
                className="form-control"
                id="item_price"
                value="1"
                disabled
              />
            </div>
            <div className="col-md-1 d-flex align-items-center justify-content-center">
              <FaExchangeAlt className="mt-4" />
            </div>
            <div className="col-md-5">
              <label htmlFor="alt_conv">
                Alternate Conversion <span className="text-danger">*</span>
              </label>
              <input
                autoComplete="off"
                type="text"
                onKeyDown={inputfourDigitDeciaml}
                // maxLength={9}
                className="form-control"
                id="alt_conv"
                {...itemFormik.getFieldProps("alt_conv")}
                disabled={unit}
              />
              {itemFormik.errors.alt_conv && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.alt_conv}
                </div>
              ) : null}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <label htmlFor="item_min_price">Min Price</label>
              <input
                autoComplete="off"
                type="text"
                onKeyDown={inputNumber}
                maxLength={9}
                className="form-control"
                id="item_min_price"
                {...itemFormik.getFieldProps("item_min_price")}
              />
              {itemFormik.errors.item_min_price && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.item_min_price}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="item_price">
                Max Price <span className="text-danger">*</span>
              </label>
              <input
                autoComplete="off"
                type="text"
                onKeyDown={inputNumber}
                maxLength={9}
                className="form-control"
                id="item_price"
                {...itemFormik.getFieldProps("item_price")}
              />
              {itemFormik.errors.item_price && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.item_price}
                </div>
              ) : null}
            </div>

            <div className="col-md-6">
              <label htmlFor="alt_min_price">Min Alternate Price</label>
              <input
                autoComplete="off"
                type="text"
                onKeyDown={inputNumber}
                maxLength={9}
                className="form-control"
                id="alt_min_price"
                disabled={unit}
                {...itemFormik.getFieldProps("alt_min_price")}
              />
              {itemFormik.errors.alt_min_price && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.alt_min_price}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="alt_price">
                Max Alternate Price <span className="text-danger">*</span>
              </label>
              <input
                autoComplete="off"
                type="text"
                onKeyDown={inputNumber}
                maxLength={9}
                className="form-control"
                id="alt_price"
                disabled={unit}
                {...itemFormik.getFieldProps("alt_price")}
              />
              {itemFormik.errors.alt_price && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.alt_price}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="barcode">Barcode</label>
              <input
                maxLength={20}
                type="text"
                className="form-control"
                id="barcode"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("barcode")}
              />
              {itemFormik.errors.barcode && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.barcode}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="SKU">SKU</label>
              <input
                maxLength={20}
                type="text"
                className="form-control"
                id="SKU"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("SKU")}
              />
              {itemFormik.errors.SKU && shownew != true ? (
                <div className="text-danger small">{itemFormik.errors.SKU}</div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="category_code">URA Category Code</label>
              <input
                maxLength={8}
                type="text"
                className="form-control"
                id="category_code"
                placeholder="Enter 8-digit URA Category Code"
                onKeyDown={(e) => {
                  if (e.ctrlKey || e.metaKey) return;
                  inputOnlyNumber(e);
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasteData = e.clipboardData
                    ? e.clipboardData.getData("text")
                    : "";
                  const pastedDigits = pasteData.replace(/\D/g, "");
                  const input = e.target;
                  const start = input.selectionStart ?? 0;
                  const end = input.selectionEnd ?? input.value.length;
                  const currentValue = itemFormik.values.category_code || "";
                  const newValue = (
                    currentValue.slice(0, start) +
                    pastedDigits +
                    currentValue.slice(end)
                  ).slice(0, 8);
                  itemFormik.setFieldValue("category_code", newValue);
                }}
                name="category_code"
                value={itemFormik.values.category_code}
                onChange={(e) => {
                  const val = e.target.value.replace(/\D/g, "").slice(0, 8);
                  itemFormik.setFieldValue("category_code", val);
                }}
                onBlur={itemFormik.handleBlur}
              />
              {itemFormik.errors.category_code && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.category_code}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="field_1">Field 1</label>
              <input
                maxLength={30}
                type="text"
                className="form-control"
                id="field_1"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("field_1")}
              />
              {itemFormik.errors.field_1 && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.field_1}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="field_2">Field 2</label>
              <input
                maxLength={30}
                type="text"
                className="form-control"
                id="field_2"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("field_2")}
              />
              {itemFormik.errors.field_2 && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.field_2}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="field_3">Field 3</label>
              <input
                maxLength={30}
                type="text"
                className="form-control"
                id="field_3"
                onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("field_3")}
              />
              {itemFormik.errors.field_3 && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.field_3}
                </div>
              ) : null}
            </div>

            <div className="col-md-6">
              <label htmlFor="video_url">Video URL</label>
              <input
                maxLength={100}
                type="text"
                className="form-control"
                id="video_url"
                // onKeyDown={inputAlphanumSpe}
                {...itemFormik.getFieldProps("video_url")}
              />
              {itemFormik.errors.video_url && shownew != true ? (
                <div className="text-danger small">
                  {itemFormik.errors.video_url}
                </div>
              ) : null}
            </div>
            <div className="col-md-12 mt-4">
              <ImageUploader
                label="Product Image *"
                imagePreview={imagePreview}
                setImagePreview={setImagePreview}
                maxSizeMB={5}
                onImageChange={(file) => {
                  setImageFile(file);
                }}
                disabled={isSubmit}
              />
            </div>
            {/* <div className="col-md-12 mt-4">
              <label className="form-label fw-bold">Product Image</label>
              <SimpleS3Upload
                setImageUrl={(url) => itemFormik.setFieldValue("image", url)}
                imageUrl={itemFormik.values.image}
                keyName="image"
                maxSizeMB={5}
              />
            </div> */}
          </div>

          <hr style={{ marginBottom: "5px" }} />
          <p
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            Opening Stock
          </p>
          <table className="table table-sm table-borderless table-hover w-100">
            <thead>
              <tr>
                <th style={{ fontSize: "12px" }}>
                  Branch <span className="text-danger">*</span>
                </th>
                <th style={{ fontSize: "12px" }}>
                  Godown <span className="text-danger">*</span>
                </th>
                <th style={{ fontSize: "12px" }}>
                  Opening Stock <span className="text-danger">*</span>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {stock &&
                stock.map((v, i) => (
                  <tr key={i}>
                    <td>
                      <select
                        style={{ width: "250px" }}
                        value={stock[i]?.branch_id || ""}
                        className="form-select"
                        onChange={(e) => {
                          setStock((prevState) =>
                            prevState.map((p, j) =>
                              i == j
                                ? {
                                    ...p,
                                    branch_id: e.target.value,
                                  }
                                : p,
                            ),
                          );
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>

                        {branchListMap?.map((list) => {
                          return (
                            <option
                              value={list?.value}
                              // hidden={stock
                              //   ?.map((s) => Number(s.branch_id))
                              //   .includes(Number(list?.value))}
                            >
                              {list?.label}
                            </option>
                          );
                        })}
                      </select>
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        {brError}
                      </span>
                    </td>
                    <td>
                      <select
                        style={{ width: "150px" }}
                        value={stock[i]?.godown_id || ""}
                        className="form-select"
                        onChange={(e) => {
                          setStock((prevState) =>
                            prevState.map((p, j) =>
                              i == j
                                ? {
                                    ...p,
                                    godown_id: e.target.value,
                                  }
                                : p,
                            ),
                          );
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>

                        {/* {godownListMap?.map((list) => {
                          return (
                            <option
                              value={list?.value}
                              hidden={stock
                                .map((s) => Number(s.godown_id))
                                .includes(Number(list?.value))}
                            >
                              {list?.label}
                            </option>
                          );
                        })} */}
                        {allGodown
                          ?.filter((f) =>
                            f.branch_id?.some((id) =>
                              stock[i]?.branch_id?.includes(id),
                            ),
                          )
                          ?.map((list) => (
                            <option
                              key={list?.godown_id}
                              value={list?.godown_id}
                              hidden={stock
                                ?.map((s) => Number(s.godown_id))
                                .includes(Number(list?.godown_id))}
                            >
                              {list?.godown_name}
                            </option>
                          ))}
                      </select>
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        {godownError}
                      </span>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={stock[i]?.op_stock}
                        onKeyDown={inputOnlyNumber}
                        maxLength={9}
                        className="form-control"
                        onChange={(e) =>
                          setStock((prevState) =>
                            prevState.map((p, j) =>
                              i == j
                                ? {
                                    ...p,
                                    op_stock: e.target.value,
                                  }
                                : p,
                            ),
                          )
                        }
                      />
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        {godownQtyError}
                      </span>
                    </td>
                    <td style={{ width: "70px" }}>
                      {/* {stock.length - 1 == i &&
                        stock[stock.length - 1]?.godown_id != "" && ( */}
                      {stock.length - 1 == i && (
                        <img
                          src={addIcon}
                          className="img-fluid m-1"
                          alt=""
                          onClick={() => {
                            // if (!stock.godown_id) {
                            //   return setDisplayError("Invalid item details");
                            // }
                            if (
                              stock[stock.length - 1].godown_id == "" ||
                              stock[stock.length - 1].op_stock == ""
                            ) {
                              Swal.fire({ html: "Please fill proper data." });
                            } else {
                              setStock((prevState) => [
                                ...prevState,
                                {
                                  godown_id: "",
                                  op_stock: "",
                                },
                              ]);

                              setGodownError("");
                              setGodownQtyError("");
                            }
                          }}
                          role="button"
                        />
                      )}
                      {stock.length > 1 && (
                        <img
                          src={deleteIcon}
                          className="img-fluid m-1"
                          alt=""
                          onClick={() =>
                            setStock([...stock.filter((s, j) => i != j)])
                          }
                          role="button"
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <hr style={{ marginBottom: "5px" }} />
          <p
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            Default Godown
          </p>
          <table className="table table-sm table-borderless table-hover w-100">
            <thead>
              <tr>
                <th style={{ fontSize: "12px" }}>Branch</th>
                <th style={{ fontSize: "12px" }}>Godown</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {item_godown_data &&
                item_godown_data.map((v, i) => (
                  <tr key={i}>
                    <td className="w-50">
                      <select
                        value={item_godown_data[i]?.branch_id || ""}
                        className="form-select"
                        onChange={(e) => {
                          setItem_godown_data((prevState) =>
                            prevState.map((p, j) =>
                              i == j
                                ? {
                                    ...p,
                                    branch_id: e.target.value,
                                  }
                                : p,
                            ),
                          );
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {branchListMap?.map((list) => {
                          return (
                            <option
                              value={list?.value}
                              hidden={item_godown_data
                                ?.map((s) => Number(s.branch_id))
                                .includes(Number(list?.value))}
                            >
                              {list?.label}
                            </option>
                          );
                        })}
                      </select>
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        {branchError}
                      </span>
                    </td>
                    <td>
                      <select
                        value={item_godown_data[i]?.godown_id || ""}
                        className="form-select"
                        onChange={(e) => {
                          setItem_godown_data((prevState) =>
                            prevState.map((p, j) =>
                              i == j
                                ? {
                                    ...p,
                                    godown_id: e.target.value,
                                  }
                                : p,
                            ),
                          );
                        }}
                      >
                        <option value="" hidden>
                          Select...
                        </option>
                        {allGodown

                          ?.filter((f) =>
                            f.branch_id?.some((id) =>
                              item_godown_data[i]?.branch_id?.includes(id),
                            ),
                          )
                          ?.map((list) => {
                            return (
                              <option value={list?.godown_id}>
                                {list?.godown_name}
                              </option>
                            );
                          })}
                      </select>
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        {defaultgodownError}
                      </span>
                    </td>
                    <td style={{ width: "70px" }}>
                      {item_godown_data.length - 1 == i && (
                        <img
                          src={addIcon}
                          className="img-fluid m-1"
                          alt=""
                          onClick={() => {
                            if (
                              item_godown_data[item_godown_data.length - 1]
                                .godown_id == "" ||
                              item_godown_data[item_godown_data.length - 1]
                                .branch_id == ""
                            ) {
                              Swal.fire({ html: "Please fill proper data." });
                            } else {
                              setItem_godown_data((prevState) => [
                                ...prevState,
                                {
                                  branch_id: "",
                                  godown_id: "",
                                },
                              ]);
                              setBranchError("");
                              setDefaultgodownError("");
                            }
                          }}
                          role="button"
                        />
                      )}
                      {item_godown_data.length > 1 && (
                        <img
                          src={deleteIcon}
                          className="img-fluid m-1"
                          alt=""
                          onClick={() =>
                            setItem_godown_data([
                              ...item_godown_data.filter((s, j) => i != j),
                            ])
                          }
                          role="button"
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <div className="row mt-4">
            <div className="col-12">
              {(error || success) && (
                <div
                  className={`alert alert-${
                    error ? "danger" : "success"
                  } py-2 small`}
                  role="alert"
                >
                  {error || success || ""}
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                <button
                  className="branchModalCancel"
                  onClick={props.hide}
                  type="reset"
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Cancel
                </button>
                {shownew ? (
                  <button
                    id="createNew"
                    type="reset"
                    style={{
                      height: "33px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      float: "right",
                    }}
                  >
                    Add New
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={isSubmit}
                    style={{
                      height: "33px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      float: "right",
                    }}
                  >
                    {isSubmit && (
                      <span className="spinner-border spinner-border-sm me-2"></span>
                    )}
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ItemCatAdd;
